import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
// import { formatPhoneNumber } from "@/utils.js";
import HyperlinkPhoneNumber from "@/components/functionals/HyperlinkPhoneNumber.vue";
//import ColorDate from "@/components/functionals/ColorDate";

export default [
  {
    prop: "ContactCode",
    name: "ContactCode",
    label: "Código de Contacto",
    width: 200,
    align: "center",
    sortable: true
  },
  {
    prop: "ContactFirstName",
    name: "ContactFirstName",
    label: "Nombre",
    width: 400,
    sortable: true
  },
  {
    prop: "ContactSurName",
    name: "ContactSurName",
    label: "Apellido",
    minWidth: 150,
    sortable: true
  },
  {
    prop: "PhoneNumber",
    name: "PhoneNumber",
    label: "Telefono",
    formatter: HyperlinkPhoneNumber, // row => formatPhoneNumber(row.PhoneNumber),
    minWidth: 200
  },
  {
    prop: "Email",
    name: "Email",
    label: "Correo",
    minWidth: 300
  },
  {
    prop: "ContactBirthday",
    name: "ContactBirthday",
    label: "Aniversario",
    //formatter: ColorDate,
    formatter: DatetimeFormatter,
    width: 200,
    sortable: true
  }
];
